<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Chyba přihlášení</div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'too-many-requests-dialog'">
        <p>Příliš mnoho pokusů o přihlášení... Zkuste to prosím později.</p>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
        <button
            (click)="dialogRef.close()"
            class="btn btn-lg orange info-text-dialog-button"
            [attr.data-testid]="'too-many-requests-dialog-button-cancel'"
            mat-button
            type="button">
            Zavřít
        </button>
    </div>
</mat-dialog-content>
